<template>
  <div class="index-box">
    <div class="index-list-bg">
      <div class="index-list-box">
        <div class="index-item-box" @click="goNext(0)">
          <div class="index-item-title">政策法规</div>
          <van-icon name="arrow" />
        </div>
        <div class="index-item-box" @click="goNext(1)">
          <div class="index-item-title">办税地图</div>
          <van-icon name="arrow" />
        </div>
        <div class="index-item-box" style="border-bottom: 0;" @click="goNext(2)">
          <div class="index-item-title">办税指南</div>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods: {
    goNext(e) {
      if(e == 0) {
        window.location.href = 'http://heilongjiang.chinatax.gov.cn/col/col17542/index.html'
      } else if(e == 1) {
        window.location.href = 'https://12366.chinatax.gov.cn/bsfw/bsdt'
      } else if(e == 2) {
        window.location.href = 'http://heilongjiang.chinatax.gov.cn/col/col7619/index.html'
      }
    },
  },
}
</script>

<style scoped>
  .index-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f2f3f8;
    overflow: auto;
  }
  .index-list-bg {
    background-color: #fff;
    box-shadow: 1px 2px 2px 1px rgba(0, 0, 0, 0.1);
    margin: 0.2rem;
    border-radius: 0.2rem;
}
.index-list-box {
    padding: 0 0.3rem;
}
.index-item-box {
    display: flex;
    align-items: center;
    padding: 0.3rem 0;
    border-bottom: 1px solid #f0f0f0;
}
.index-item-title {
    font-size: 0.3rem;
    color: #1a1a1a;
    flex: 1;
    text-align: left;
}
</style>